<template>
    <div class="about-us-wrap">
        <div class="top-wrap">
            <div class="text-wrap">
                <div class="title">关于我们</div>
                <div class="sub-title">福建驰城通科技有限公司是行业领先的互联网应用服务商，专注于互联网创新模式软件开发，拥有强大的技术团队。集系统开发、小程序定制、APP定制、社区团购定制、高端网站定制开发为一体。为企业提供一站式信息化解决方案，助力企业信息化转型成功。</div>
            </div>
            <!-- <img src="../assets/banner_img.png" alt=""> -->
            <!-- <img src="../assets/banner_img.png" alt=""> -->
            <img src="../assets/banner/banner_img_icon_1.png" alt="">
        </div>
       <!-- <div class="desc-wrap">
        福建驰城通科技有限公司，专注于智慧出行系统、电子商务平台、新媒体解决方案的研发，客户从初创公司到世界500强为主，是一家朝气蓬勃的国家高新技术企业。已协助多家网约车出行平台成功运营,欢迎关注“驰城通科技”官方微信公众号了解最新动态。
       </div> -->
       <div class="rows-wrap">
             <div class="row-item">
                <img src="../assets/about/about_1.png" alt="">
                <div class="text-wrap left">
                    <div class="title">◆ 产品介绍 ◆</div>
                    <div class="desc">驰城通智慧出行：结合国内互联网出行服务市场行业现状，自主研发原生互联网出行服务软件。
                        驰城通科技紧跟市场步伐，为了切合市场需要，公司资深技术研发团队凭借多年积累的丰富开发经验，在软件开发方面不断的保持更新，让产品实时符合市场发展规律，同时不断研发新的产品以便满足更多用户的市场需求。</div>
                </div>
             </div>
             <div class="row-item">
                <div class="text-wrap">
                    <div class="title">◆ 主营产品 ◆</div>
                    <div class="desc">驰城通智慧出行包含（快车、跑腿、城际车、顺风车、专车、出租车、代驾、租车）涵盖客户端（安卓/IOS）、微信端、司机端（安卓/IOS）、PC后台管理端共4大端口。
                        e家代驾系统。涵盖客户端（安卓/IOS）、小程序、车主端（安卓/IOS）、运维端（安卓/IOS）、PC后台管理端共5大端口。</div>
                </div>
                <img class="left" src="../assets/about/about_2.png" alt="">

             </div>
             <div class="row-item">
                <img src="../assets/about/about_3.png" alt="">
                <div class="text-wrap left">
                    <div class="title">◆ 服务介绍 ◆</div>
                    <div class="desc">售前：提供专业的售前咨询客服为您服务
售中：提供专业的售中产品经理为您解答产品中遇到的疑惑。
研发：提供专业的技术研发团队进行产品开发。
售后：提供专业的售后服务工作进行后续的（升级/运维服务）。</div>
                </div>
             </div>
             <div class="row-item">
                <div class="text-wrap">
                    <div class="title">◆ 企业文化 ◆</div>
                    <div class="desc">驰城通科技：秉承“为合作伙伴创造价值”的核心价值观，并以“诚实、宽容、创新、服务”为企业精神，通过自主创新和真诚合作为电子商务及信息服务行业创造价值。
                        驰城通智慧出行：我们认为诚信是一切合作的基础，宽容是解决问题的前提，创新是发展事业的利器，服务是创造价值的根本。</div>
                </div>
                <img class="left" src="../assets/about/about_4.png" alt="">

             </div>
            <div class="xx"></div>
       </div>
    </div>
   </template>
   
   <script>
   export default {
     data () {
       return {
         
       }
     },
     computed: {
     },
     mounted() {
     },
   }
   
   </script>
   <style scoped lang="scss">
   .about-us-wrap{
       .top-wrap{
           height: 450px;
           background: #466dff;
           display: flex;
           align-items: center;
           justify-content: center;
           .text-wrap{
               width: 450px;
               // background: orange;
               margin-right: 50px;
               color: white;
               .title{
                   font-size: 30px;
                   margin-bottom: 20px;
               }
               .sub-title{
                   font-size: 16px;
               }
           }
       }
        .desc-wrap{
            width: 70%;
            text-align: left;
            margin: 0 auto;
            color: #999;
            font-size: 16px;
            line-height: 24px;
        }
        .rows-wrap{
            width: 70%;
            margin: 40px auto;
            .row-item{
                display: flex;

                .left{
                    margin-left: 60px;
                }
                .text-wrap{
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    .title{
                        color: #466dff;
                        font-size: 30px ;
                        margin-bottom: 20px;

                    }
                    .desc{
                        color: #333;
                        font-size: 14px;
                        line-height: 24px;
                        font-family: 'Microsoft YaHei',"Helvetica Neue",Helvetica,'PingFang SC',Arial,sans-serif !important;
                    }
                }
            }
        }
   }
   </style>
   